export { useMyParcelsRightSectionCopy } from './useMyParcelsRightSectionCopy.hook';
